var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67 3.693l3.747 4.31a.5.5 0 00.71.045L14 1",
    stroke: "#047DE0",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "3db409d0c4515b65ee0234af8849d2a2.svg";
export { SvgIconCheckBlue as ReactComponent };